var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M2 4h20v3H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B600",
    d: "M2 20h20v-3H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M4.53 9.86A5.832 5.832 0 003 9.223l.02-.12h2.349c.316.012.572.121.66.49l.511 2.67c-.345-.96-1.025-1.81-2.01-2.403l-.008-.035c.925.504 1.752 1.51 2.018 2.438l.153.806 1.426-3.963h1.544l-2.295 5.802H5.826L4.531 9.86zm4.811 5.054l.912-5.813h1.457l-.912 5.813H9.341zm6.742-5.67l-.197 1.26-.13-.066a2.496 2.496 0 00-1.091-.224c-.571 0-.835.259-.835.5-.004.273.309.452.818.721.84.415 1.23.917 1.224 1.58C15.86 14.22 14.866 15 13.335 15c-.654-.007-1.284-.148-1.624-.31l.204-1.3.188.092c.479.217.789.304 1.372.304.419 0 .868-.178.872-.567.002-.255-.188-.437-.756-.722-.553-.277-1.285-.743-1.276-1.579C12.323 9.788 13.337 9 14.778 9c.564 0 1.017.127 1.305.244zm3.738-.137L21 14.916h-1.352s-.134-.668-.178-.871l-1.866-.003c-.057.157-.306.874-.306.874h-1.53l2.163-5.327c.153-.379.415-.482.764-.482h1.126zm-1.798 3.746h1.21l-.337-1.678-.099-.501c-.073.218-.202.57-.193.554l-.58 1.625z"
  }))));
}

export default SvgVisa;